export const CONTENT_PAGES = {
  INFO: 'info_pages',
  SLIDERS: 'main_sliders',
  IOS: 'ios_app',
  LOYALTY_RULES: 'loyalty_rules',
  SEO: 'seo_pages',
  ABOUT_SHOP: 'about_shop',
  MORE_ABOUT_SHOP: 'more_about_shop',
  TOURNAMENTS: 'tournaments',
  PAYMENT_PENDING: 'payment_pending',
  APP: 'install_app',
  JACKPOTS: 'jackpots'
};
